"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEntryPoint = exports.getElementComponentName = exports.getByDotNotation = exports.compareObjects = exports.getCreativityDraftInfo = exports.addEmptyCreativityToList = exports.getCreativitiesList = exports.deleteByDotNotation = exports.makeUpObj = exports.deleteFromSession = exports.saveToSession = exports.getFromSession = exports.addElement2Structure = exports.sortObjectByKeys = exports.CREATIVITY_LIST = exports.SIDE = exports.DEEP = void 0;
exports.DEEP = 'deep';
exports.SIDE = 'aside';
exports.CREATIVITY_LIST = 'creativity-list';
function sortObjectByKeys(structure, keySort) {
    const sortedObject = {};
    const unsortedKeys = Object.keys(structure).filter(key => !keySort.includes(key));
    const sortedKeys = [...keySort, ...unsortedKeys];
    sortedKeys.forEach(key => {
        sortedObject[key] = structure[key];
    });
    return sortedObject;
}
exports.sortObjectByKeys = sortObjectByKeys;
const addElement2Structure = ({ obj, componentName, position, template }) => {
    const res = Object.assign({}, obj);
    // elimino todas las claves que contengan el componentName
    const object2Sort = [];
    Object.keys(res).forEach((key, index) => {
        if (key.indexOf(componentName) !== -1) {
            object2Sort.push(res[key]);
            delete res[key];
        }
    });
    object2Sort.splice(position, 0, template);
    object2Sort.forEach((element2Insert, index) => {
        res[`${componentName}-${index}`] = element2Insert;
    });
    return Object.assign({}, res);
};
exports.addElement2Structure = addElement2Structure;
const getFromSession = (name, output = 'json') => {
    let info = '';
    try {
        if (name) {
            info = sessionStorage.getItem(name);
            if (output === 'json') {
                info = JSON.parse(info);
            }
            return info;
        }
    }
    catch (error) {
        // console.error(error);
        return info;
    }
};
exports.getFromSession = getFromSession;
const saveToSession = (name, info, input = 'json') => {
    try {
        let fInfo = info;
        if (input === 'json') {
            fInfo = JSON.stringify(fInfo);
        }
        sessionStorage.setItem(name, fInfo);
    }
    catch (error) {
        // console.error(error);
    }
};
exports.saveToSession = saveToSession;
const deleteFromSession = (name) => {
    try {
        sessionStorage.removeItem(name);
    }
    catch (error) {
        //console.error(error);
    }
};
exports.deleteFromSession = deleteFromSession;
const makeUpObj = (key, value) => {
    const obj = {};
    const parts = key.split('.');
    if (parts.length === 1) {
        obj[parts[0]] = value;
    }
    else if (parts.length > 1) {
        // concat all but the first part of the key
        const remainingParts = parts.slice(1, parts.length).join('.');
        obj[parts[0]] = (0, exports.makeUpObj)(remainingParts, value);
    }
    return obj;
};
exports.makeUpObj = makeUpObj;
const deleteByDotNotation = (obj, prop) => {
    const parts = prop.split(".");
    const lastPart = parts.pop();
    let currentObj = obj;
    for (const part of parts) {
        currentObj = currentObj[part];
        if (typeof currentObj !== "object") {
            return obj;
        }
    }
    delete currentObj[lastPart];
    return obj;
};
exports.deleteByDotNotation = deleteByDotNotation;
const getCreativitiesList = () => (0, exports.getFromSession)(exports.CREATIVITY_LIST);
exports.getCreativitiesList = getCreativitiesList;
const addEmptyCreativityToList = (creativityId) => {
    const lastCreativityList = (0, exports.getCreativitiesList)() || [];
    lastCreativityList.push(creativityId);
    (0, exports.saveToSession)(exports.CREATIVITY_LIST, lastCreativityList);
};
exports.addEmptyCreativityToList = addEmptyCreativityToList;
const getCreativityDraftInfo = (creativityId) => {
    let creativityList = (0, exports.getCreativitiesList)();
    if (!creativityList || creativityList.indexOf(creativityId) === -1) {
        (0, exports.addEmptyCreativityToList)(creativityId);
        creativityList = (0, exports.getCreativitiesList)();
    }
    return creativityList;
};
exports.getCreativityDraftInfo = getCreativityDraftInfo;
const compareObjects = (obj1, obj2) => {
    let differences = {};
    for (let key in obj1) {
        if (obj2.hasOwnProperty(key)) {
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                let diff = (0, exports.compareObjects)(obj1[key], obj2[key]);
                if (Object.keys(diff).length > 0) {
                    differences[key] = diff;
                }
            }
            else if (obj1[key] !== obj2[key]) {
                differences[key] = [obj1[key], obj2[key]];
            }
        }
        else {
            differences[key] = [obj1[key], undefined];
        }
    }
    for (let key in obj2) {
        if (!obj1.hasOwnProperty(key)) {
            differences[key] = [undefined, obj2[key]];
        }
    }
    return differences;
};
exports.compareObjects = compareObjects;
const getByDotNotation = (obj, dotSelector) => {
    var arr = dotSelector.split(".");
    while (arr.length && (obj = obj[arr.shift()]))
        ;
    return obj;
};
exports.getByDotNotation = getByDotNotation;
const getElementComponentName = (entryPoint) => {
    const token = entryPoint.split('.');
    const element = token[token.length - 1];
    const etoken = element.split('-');
    return etoken[0];
};
exports.getElementComponentName = getElementComponentName;
const addEntryPoint = ({ custoObjectInfo, entryPoint = "", kind = exports.DEEP, }) => {
    let res = Object.assign({}, custoObjectInfo);
    //regular way
    if (!res) {
        return null;
    }
    //edit way and entrypoint
    if (entryPoint && !res.entryPoint) {
        res.entryPoint = entryPoint;
    }
    else if (entryPoint && kind === exports.DEEP) {
        res.entryPoint = `${res.entryPoint}.${entryPoint}`;
    }
    return res;
};
exports.addEntryPoint = addEntryPoint;
exports.default = exports.addEntryPoint;
//# sourceMappingURL=index.js.map